import { render, staticRenderFns } from "./courseLimit.vue?vue&type=template&id=0154f6ec&scoped=true&"
import script from "./courseLimit.vue?vue&type=script&lang=js&"
export * from "./courseLimit.vue?vue&type=script&lang=js&"
import style0 from "./courseLimit.vue?vue&type=style&index=0&id=0154f6ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0154f6ec",
  null
  
)

export default component.exports